import React, {useState} from 'react'

// CSS
import '../../../../css/forms/info-changes.css';

// Components
import InfoChangesContent from './InfoChangesContent';

const InfoChanges = ({date_modified, oldData, newData}) => {
    const [isOpen, setOpen] = useState(false);

    return (
        <div className='info-changes'>
            <div className={`info-changes-header ${isOpen && 'open'}`} onClick={() => setOpen(setOpen => !setOpen)}>
                <div className="info-changes-header-left">
                    <span className="icon-checkmark"></span>
                    <div>This reviewer has recently changed their profile on: <strong>{date_modified}</strong></div>
                </div>
                <span className={`icon-keyboard_arrow_${isOpen ? 'up' : 'down'}`}></span>
            </div>
            {isOpen && <InfoChangesContent oldData={oldData} newData={newData} />}
        </div>
    )
}

export default InfoChanges


// WEBPACK FOOTER //
// ./src/components/admin/reviewers/info-changes/InfoChanges.js